import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
     baseUrl : "https://api.pelicanrx.com",
});

export const apiSlice = createApi({
    baseQuery,
    endpoints: builder => ({}),
    tagTypes: ["Appointments"],
})